import actionConsts from './../../constants/actions';

const onboarding = (state = [], action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return action.payload.onboardingData ? {} : [];
        default:
            return state;
    }
};

export default onboarding;


// WEBPACK FOOTER //
// /src/reducers/onboarding/index.js